import React from "react";
import { Calendar, Check } from "lucide-react";
import { EVENT, HERO, FORM_BENEFITS, ASSETS } from "../../mock";
import Countdown from "../Countdown";
import RegistrationForm from "../RegistrationForm";

const Hero = () => {
  const scrollToForm = () => {
    document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen overflow-hidden" data-testid="hero-section">
      {/* Background image + overlays */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${ASSETS.house})` }}
      />
      <div className="absolute inset-0 bg-[#070b16]/85" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#070b16]/60 via-transparent to-[#070b16]" />
      <div className="absolute inset-0 blueprint-grid opacity-30" />

      <div className="relative max-w-7xl mx-auto px-6 pt-32 pb-20 grid lg:grid-cols-[1.15fr_0.85fr] gap-12 items-start">
        {/* Left */}
        <div className="reveal">
          <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-[#8fa8d4] uppercase mb-3">
            <Calendar size={12} /> {EVENT.dateLabel}
          </div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-[#6f7d9f] uppercase mb-8">{EVENT.eyebrow}</p>

          <h1 className="font-heading uppercase leading-[0.92] text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight" data-testid="hero-headline">
            {HERO.headline1}{" "}
            <span className="text-[#6b9be8]">{HERO.headline2}</span>
            <span className="block text-[0.72em] text-[#8b99b8] mt-1">{HERO.headline3}</span>
          </h1>

          <p className="mt-6 text-[#c3cde2] text-base sm:text-lg leading-relaxed max-w-xl">{HERO.sub}</p>

          <blockquote className="mt-6 border-l-2 border-[#6b9be8] pl-4 text-[#9db8e8] italic text-sm sm:text-base max-w-lg">
            {HERO.quote}
          </blockquote>

          <p className="mt-10 font-mono text-[10px] tracking-[0.3em] text-[#6f7d9f] uppercase mb-4">{HERO.countdownLabel}</p>
          <Countdown target={EVENT.targetDate} />

          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <button
              onClick={scrollToForm}
              data-testid="hero-cta"
              className="flex items-center gap-2 bg-[#3f639f] hover:bg-[#4f76b8] text-white font-mono text-xs tracking-[0.25em] uppercase px-8 py-4 transition-colors cta-glow"
            >
              <Check size={15} /> {HERO.cta}
            </button>
            <span className="font-mono text-[10px] tracking-[0.2em] text-[#d4a24a] uppercase animate-pulse-slow">{HERO.notice}</span>
          </div>

          <div className="mt-12 flex items-center gap-4">
            <img src={ASSETS.oscar} alt="Oscar Tobar" className="w-14 h-14 object-cover border border-[#22304e]" />
            <div>
              <p className="text-white text-sm font-semibold">{EVENT.host}</p>
              <p className="text-[#7f8db0] text-xs">{EVENT.company} · {EVENT.nmls}</p>
            </div>
          </div>
        </div>

        {/* Right — form card */}
        <div id="register" className="reveal scroll-mt-28">
          <div className="border border-[#22304e] bg-[#0c1324]/95 backdrop-blur p-6 sm:p-8 shadow-[0_20px_60px_rgba(0,0,0,0.55)]" data-testid="hero-form-card">
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#d4a24a] uppercase mb-2">Don't Miss Out</p>
            <h3 className="font-heading text-white text-xl uppercase tracking-tight mb-5">When You Register, You'll Receive:</h3>
            <ul className="space-y-2.5 mb-5">
              {FORM_BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-2.5 text-sm text-[#c3cde2]">
                  <Check size={15} className="text-[#6b9be8] mt-0.5 shrink-0" /> {b}
                </li>
              ))}
            </ul>
            <p className="font-heading text-[#6b9be8] text-2xl uppercase mb-5">FREE!</p>
            <RegistrationForm idPrefix="hero" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
